var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(!_vm.waitForData) ? _c('form', {
    attrs: {
      "data-testid": "registration-address-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-around"
  }, [_c('span', {
    attrs: {
      "data-testid": "registration-address-czech-label"
    }
  }, [_vm._v("Česká")]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-lg switch-text switch-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOutsideCzechia),
      expression: "searchOutsideCzechia"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "searchInCzechia",
      "data-testid": "registration-address-foreign-toggle"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchOutsideCzechia) ? _vm._i(_vm.searchOutsideCzechia, null) > -1 : (_vm.searchOutsideCzechia)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.searchOutsideCzechia,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchOutsideCzechia = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.searchOutsideCzechia = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.searchOutsideCzechia = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "",
      "data-off": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "data-testid": "registration-address-foreign-label"
    }
  }, [_vm._v("zahraniční")])]), _vm._v(" "), (!_vm.searchOutsideCzechia) ? [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "search",
      "data-testid": "registration-address-search-czech",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat adresu",
      "open-direction": "bottom",
      "options": _vm.addresses,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.openAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(_vm._s(props.option.values.WHOLE_ADDRESS))])]), _vm._v(" "), _c('div', {
          staticClass: "row m-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-12"
        }, [_c('span', [_vm._v(_vm._s(props.option.values.DISTRICT))]), _vm._v(", \n                                                              "), _c('span', [_vm._v(_vm._s(props.option.values.REGION))])])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])] : [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "searchForeign",
      "data-testid": "registration-address-search-foreign",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat adresu v cizině",
      "open-direction": "bottom",
      "options": _vm.foreignAddresses,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getForeignAddressResult,
      "select": _vm.openForeignAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(_vm._s(props.option.description))])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])], _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-9"
  }, [_c('label', {
    attrs: {
      "for": "street"
    }
  }, [_vm._v("Ulice")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.street),
      expression: "address.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "streetHelp",
      "id": "street",
      "data-testid": "registration-address-street",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.street = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.street) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "streetError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.street.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "houseNumber"
    }
  }, [_vm._v("Číslo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.house_number),
      expression: "address.house_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "houseNumberHelp",
      "id": "houseNumber",
      "data-testid": "registration-address-house-number",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.house_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.house_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.housenumber) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "houseNumberError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.housenumber.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "zip_code"
    }
  }, [_vm._v("PSČ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.zip_code),
      expression: "address.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "zip_codeHelp",
      "id": "zip_code",
      "data-testid": "registration-address-zip-code",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.zip_code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.zipcode) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "zipCodeError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.zipcode.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Město")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.city),
      expression: "address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "cityHelp",
      "id": "city",
      "data-testid": "registration-address-city",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.city) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "cityError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.city.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "district"
    }
  }, [_vm._v("Okres")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.district),
      expression: "address.district"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "districtHelp",
      "id": "district",
      "data-testid": "registration-address-district",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.district = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.district) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "districtError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.district.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "region"
    }
  }, [_vm._v("Kraj")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.region),
      expression: "address.region"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "regionHelp",
      "id": "region",
      "data-testid": "registration-address-region",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.address.region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address.region = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.region) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "regionError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.region.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.addressPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-address-save"
    }
  }, [_vm._v("Uložit adresu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])], 2) : _vm._e(), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(0)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aff38a0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Registration/components/RegistrationClientAddress.vue
// module id = 475
// module chunks = 0